const { default: IcoMoon } = require('react-icomoon')
import iconSet from './selection.json'
import { getIconName } from './iconMapper'

const IcoMoonIcon = ({ icon, width = '24', height = '24', ...rest }) => {
  const name = getIconName(icon) || icon
  return <IcoMoon iconSet={iconSet} icon={name} width={width} height={height} {...rest} />
}

export default IcoMoonIcon
